import { ROUTES } from '../../constants/routes';

export const SecurityAttributes = {
    PortalsFullAccess: 1,
    PortalsReadOnly: 2,

    PopulationFullAccess: 3,
    PopulationReadOnly: 4,

    IndividualFullAccess: 5,
    IndividualReadOnly: 6,
    IndividualAccountActions: 7,

    TemplatesFullAccess: 8,
    TemplatesReadOnly: 9,

    OrganizationLevelsFullAccess: 10,
    OrganizationLevelsReadOnly: 11,

    ImportsFileImport: 12,
    ImportsAutoImport: 13,
    ImportsAutoImportReadOnly: 14,

    SecurityRolesFullAccess: 15,
    SecurityRolesReadOnly: 16,

    ThemeFullAccess: 17,
    ThemeReadOnly: 18,

    UserAccountFullAccess: 19,
    UserAccountReadOnly: 20,

    UserAccountPasswordReset: 22,

    ClientAssignFullAccess: 23,
    ClientAssignReadOnly: 24,

    AdminSecurityRolesFullAccess: 25,
    AdminSecurityRolesReadOnly: 26,

    GlobalSSOFullAccess: 27,
    GlobalSSOReadOnly: 28,

    ClientSSOFullAccess: 29,
    ClientSSOReadOnly: 30,

    ClientFullAccess: 31,
    ClientReadOnly: 32,

    NotificationFullAccess: 33,
    NotificationReadOnly: 34,

    ViewPrivateAssets: 35,
    ViewUnassignedAssets: 36,
    LockUnlockAssets: 37,

    PortalActions: 38,
    PortalActionsAssetUpload: 39,

    IndividualDelete: 42,

    AgencyFullAccess: 43,
    AgencyReadOnly: 44,

    ViewLog: 45,

    ClientSettingsFullAccess: 50,
    ClientSettingsReadOnly: 51,
    ClientOptionsFullAccess: 52,
    ClientOptionsReadOnly: 53,
    ClientDelete: 54,
    BillingFullAccess: 55,
    BillingReadOnly: 56,

    VendorFullAccess: 57,
    VendorFullAccessReadOnly: 58,

    MultiTenantPortalTemplatesFullAccess: 59,
    MultiTenantPortalTemplatesReadOnly: 60,

    ImpersonationMultitenant: 63,
    ImpersonationClient: 64,
    PlanDetailFullAccess: 61,
    PlanDetailReadOnly: 62,
    MultiImportQueueAccess: 66,
    MultiImportQueueEnhancedReviewAccess: 67,
    GlobalAssetsFullAccess: 68,

    UserAccessBenefits: 70,
    UserAccessPortals: 71,
    UserAccessSSOs: 72,
    UserAccessPrivateAssets: 73,

    BenefitsReadOnly: 74,
    BenefitsFullAccess: 75,
    CustomImportsReadOnly: 76,
    CustomImportsFullAccess: 77,
    ImportQueue: 78,
    ManageAudience: 79,

    AllReportsAccess: 80,
    ReportsAccess: 81,

    AssetLibraryReadOnly: 82,

    ResourceLibraryFullAccess: 83,
    ResourceLibraryReadOnly: 84,

    MultiTenantNotificationTemplatesFullAccess: 85,
    MultiTenantNotificationTemplatesReadOnly: 86,
};

export const ResourceScope = {
    Global: 1,
    Agency: 2,
    ClientAdmin: 4,
    Individual: 8,
};

export const ResourceProgressStatusEnum = {
    NotStarted: 1,
    InProgress: 2,
    Completed: 3,
};

export const TenantUserType = {
    MultiClient: 1,
    ClientAdmin: 2,
    Individual: 3,
    LimitedUser: 4,
};

export const ContainerTypes = {
    EnrollmentByAge: 1,
    PremiumByPlanType: 2,
    Video: 3,
    Text: 4,
    Location: 5,
    Image: 6,
    Table: 7,
    Document: 8,
    Multimedia: 9,
    ChildPortal: 10,
    Link: 11,
    AssetUpload: 12,
};

export const EventDataTypeEnum = {
    TenantUser: 1,
    Asset: 2,
    Tenant: 3,
    TenantSSO: 4,
    Individual: 5,
    Portal: 6,
    Container: 7,
    Benefits: 8,
    AssetLibrary: 9,
};

export const NOTIFICATION_METHOD = {
    primaryEmail: 1,
    primaryPhone: 2,
    pushNotification: 3,
    optionalEmail: 4,
    optionalPhone: 5,
};

export const PushDestinationType = {
    FullMessage: 1,
    WebsiteUrl: 2,
    Portal: 3,
    Menu: 4,
    SSO: 5,
    Asset: 6,
};

export const PUSH_DESTINATION_OPTIONS = [
    {
        value: 'full-message',
        typeId: PushDestinationType.FullMessage,
        labelKey: 'msg_cb1d5ebbe195',
    },
    {
        value: 'website',
        typeId: PushDestinationType.WebsiteUrl,
        labelKey: 'msg_2e8a57cc5c47',
    },
    {
        value: 'portal',
        typeId: PushDestinationType.Portal,
        labelKey: 'msg_b55223c7bdc7',
    },
    {
        value: 'sso',
        typeId: PushDestinationType.SSO,
        labelKey: 'msg_5fa55a6001cc',
    },
    {
        value: 'menu',
        typeId: PushDestinationType.Menu,
        labelKey: 'msg_57f5f5efbc59',
    },
    {
        value: 'asset',
        typeId: PushDestinationType.Asset,
        labelKey: 'msg_4426afd90a77',
    },
];

export const PushMenuDestination = {
    Home: ROUTES.ROOT,
    Assets: ROUTES.MY_ASSETS,
    Benefits: ROUTES.MY_BENEFITS,
    Messages: ROUTES.MY_MESSAGES,
};

export const PUSH_MENU_DESTINATIONS = [
    { value: PushMenuDestination.Home, labelKey: 'msg_70f8bb9a8a53' },
    { value: PushMenuDestination.Assets, labelKey: 'msg_20e338624cee' },
    { value: PushMenuDestination.Benefits, labelKey: 'msg_927f40673764' },
    { value: PushMenuDestination.Messages, labelKey: 'msg_f1702b468627' },
];

export const LogEventType = {
    LoginSuccessful: 1,
    LoginFailed: 2,
    TokenRefreshed: 3,
    Logout: 4,
    MFAFailed: 5,
    NavigatedToMenu: 6,
    NavigatedToPage: 7,
    CancelClicked: 8,
    SaveClicked: 9,
    DeleteClicked: 10,
    UserLinkClicked: 11, // context only; no subject fields
    UserVideoPlayed: 12, // context only; no subject fields
    UserVideoPercentageViewed: 13, // context only; no subject fields
    UserDocumentViewed: 14, // context only; no subject fields
    UserDocumentDownloaded: 15, // context only; no subject fields
    UserAcknowledgementUpdated: 16, // context only; no subject fields
    AssetUploaded: 18,
    AssetCreated: 19,
    AssetUpdated: 20,
    AssetDeleted: 21,
    UserProfilePictureUploaded: 22,
    UserCommsUpdated: 23,
    UserCommPrefsUpdated: 24,
    UserPreferredNameUpdated: 25,
    UserPronounsUpdated: 26,
    UserNotificationOptOutsUpdated: 27,
    UserPasswordUpdated: 28,
    AdminIndividualViewChanged: 29,
    ImpersonationStarted: 30,
    ImpersonationEnded: 31,
    CustomImportAdded: 32,
    CustomImportUpdated: 33,
    CustomImportDeleted: 34,
    SSOAdded: 35,
    SSOUpdated: 36,
    SSODeleted: 37,
    DataDownloaded: 38,
    LogReportRan: 39,
    AccountPasswordChanged: 42,
    AccountStatusChanged: 44,
    NotificationSent: 45,
    ClientCreated: 46,
    ClientDeleted: 47,
    SMSBalanceIncremented: 48,
    SMSBalanceIncrementedMonthly: 49,
    AutoImportUnprocessedFile: 50,
    UserLanguageUpdated: 51,
    ClientFavorited: 52,
    ClientUnfavorited: 53,
    ClientUpdated: 54,
    UserSSOLoginAttempt: 55,
    IndividualAdded: 56,
    IndividualUpdated: 57,
    IndividualDeleted: 58,
    UserSecurityRoleUpdated: 59,
    UserCreated: 62,
    UserUpdated: 63,
    UserDeleted: 64,
};

export const LogEventTypeSeverity = {
    Debug: 1,
    Info: 2,
    Error: 3,
    Critical: 4,
};

export const ImportFileFormat = {
    Delimited: 1,
    Excel: 2,
    FixedLength: 3,
};

export const ImportDelimiter = {
    Comma: 1,
    Pipe: 2,
    Tab: 3,
    Custom: 4,
};

export const ImportType = {
    Demographic: 1,
    Enrollment: 2,
    BenefitPlan: 3,
    PlanDetails: 4,
    OrgLevel: 5,
    DataPoint: 6,
};

export const TenantUserStatusEnum = {
    None: 0,
    NotStarted: 1,
    Pending: 2,
    Active: 3,
    Inactive: 4,
    Disabled: 5,
    Locked: 6,
};

export const IndividualSearchSortField = {
    LastName: 1,
    FirstName: 2,
    UniqueId: 3,
    EmploymentStatus: 4,
    EmploymentCategory: 5,
    JobTitle: 6,
    TenantUserStatus: 7,
    LastLoginDate: 8,
};

export const GenderEnum = {
    1: 'M',
    2: 'F',
};

export const TenantStatus = {
    Live: 1,
    Test: 2,
    Demo: 3,
    Inactive: 4,
    Template: 5,
    InProgress: 6,
    ScheduledForDeletion: 7,
    Contracting: 8,
    Prelaunch: 9,
};

export const DashboardTypeEnum = {
    Registration: 1,
    EmploymentStatus: 2,
    SessionsByDevice: 3,
    SessionsDaily: 4,
    MostVisitedPages: 5,
    MostClickedContent: 6,
    MessagesUserPreference: 7,
    MessagesSent: 8,
    ClientStatus: 9,
    ClientTier: 10,
};

export const BenefitsViewModeEnum = {
    None: 0,
    Grid: 1,
    List: 2,
};

export const tenantTierLabels = {
    1: 'Base',
    2: 'Bronze',
    3: 'Silver',
    4: 'Gold',
};

export const TenantTiers = {
    Base: 1,
    Bronze: 2,
    Silver: 3,
    Gold: 4,
};

export const tenantTierAllocations = [
    {
        id: 1,
        name: tenantTierLabels[1],
        allocationType: 'Monthly Allocation',
        monthlySMSAllocationAmount: 5000,
        incrementalSMSAllocationAmount: null,
        incrementalSMSAllocationCost: null,
    },
    {
        id: 2,
        name: tenantTierLabels[2],
        allocationType: 'Monthly Allocation',
        monthlySMSAllocationAmount: 5000,
        incrementalSMSAllocationAmount: null,
        incrementalSMSAllocationCost: null,
    },
    {
        id: 3,
        name: tenantTierLabels[3],
        allocationType: 'Monthly Allocation',
        monthlySMSAllocationAmount: 10000,
        incrementalSMSAllocationAmount: null,
        incrementalSMSAllocationCost: null,
    },
    {
        id: 4,
        name: tenantTierLabels[4],
        allocationType: 'Monthly Allocation',
        monthlySMSAllocationAmount: 20000,
        incrementalSMSAllocationAmount: null,
        incrementalSMSAllocationCost: null,
    },
    {
        id: null,
        name: null,
        allocationType: 'Incremental Allocation',
        monthlySMSAllocationAmount: 0,
        incrementalSMSAllocationAmount: 5000,
        incrementalSMSAllocationCost: 100.0,
    },
];

export const ClientOptionEnum = {
    CreateOrgLevelsOnImport: 1,
    RegistrationIdentifiers: 2,
    PasswordMinimumLength: 3,
    PasswordMaximumLength: 4,
    PasswordHistoryCount: 5,
    PasswordAllowDuplicateValues: 6,
    DisplayBenefitText: 7,
    BenefitText: 8,
    DisplayEmployeeCosts: 9,
    DisplayEmployerCosts: 10,
    DisplayOutOfNetworkInformation: 11,
    OptOutOfCategories: 12,
    FieldNaming: 13,
    AccountAccessEndDateRules: 14,
    DisplayBenefitsModule: 15,
    BenefitsModuleIndividuals: 16,
    CommunicationPreference: 18,
    ReviewDemographicImports: 19,
    ReviewEnrollmentImports: 20,
    EnableAdditionalUserAccounts: 21,
    EnableUserSelfRegistration: 22,
    SelfRegistrationIdentifiers: 23,
    EmailSenderName: 24,
    RegistrationCommunication: 25,
    PasswordResetCommunication: 26,
    AdditionalUserEmailCommunication: 27,
    AdminAudienceEnabled: 28,
    RenameBenefitsMenu: 29,
    RenameAssetsMenu: 30,
    RenameMessagesMenu: 31,
    EnableEmailAndPhoneValidation: 32,
    DisplayIndividualAssetMenu: 33,
    AllowAssetUpload: 34,
    AllowAssetSharing: 35,
    IndividualBenefitsView: 36,
    DataPointsEnabled: 37,
};

export const VendorCategoryEnum = {
    1: 'HRIS',
    2: 'Payroll',
    3: 'HR Payroll',
    4: 'Carrier',
    5: 'Ben Admin',
    6: 'Wellness',
};

export const EmployementCategoryEnum = {
    Employee: 1,
};

export const EmployementStatusEnum = {
    Active: 1,
};

export const relationshipMap = {
    1: 'Spouse',
    2: 'Domestic Partner',
    3: 'Parent',
    4: 'Dependent',
    5: 'Caregiver',
    6: 'Conservator',
    7: 'Child',
    8: 'Other',
};

export const PlanTypeEnum = {
    Medical: 1,
    Dental: 2,
    Vision: 3,
    HealthcareFSA: 4,
    DependentCareFSA: 5,
    LimitedPurposeFSA: 6,
    HSA: 7,
    HRA: 8,
    LTD: 9,
    STD: 10,
    BasicLife: 11,
    VolEELife: 12,
    VolSpouseLife: 13,
    VolChildLife: 14,
    WholeLife: 15,
    HospitalIndemnity: 16,
    CriticalIllness: 17,
    Accident: 18,
    Cancer: 19,
    Legal: 20,
    IdentityTheft: 21,
    PetInsurance: 22,
    Four01K: 24,
    Four01KRoth: 25,
    Four03B: 26,
    ParkingTransitFSA: 27,
    EAP: 28,
    AccidentalDeathAndDismemberment: 29,
    SupplementalChildADAndD: 30,
    SupplementalEEADAndD: 31,
    SupplementalSpouseADAndD: 32,
    LongTermCare: 33,
    Voluntary: 34,
    Other: 35,
    VolLTD: 36,
    VolSTD: 37,
    CriticalIllness2: 38,
    CriticalIllness3: 39,
    CriticalIllness4: 40,
    TobaccoSurcharge: 41,
    SpouseSurcharge: 42,
    WellnessCredit: 43,
};

export const UserType = {
    MultiClient: 1,
    ClientAdmin: 2,
    Individual: 3,
    LimitedUser: 4,
};

export const SecurityAttributeAppliesTo = {
    Individual: 1, // 1 << 0
    ClientAdmin: 2, // 1 << 1
    MultiClient: 4, // 1 << 2
};

export const IdentifierEnum = {
    None: 0,
    EmailAddress: 1,
    DOB: 2,
    FirstName: 3,
    Last4SSN: 4,
    LastName: 5,
    Birthday: 6,
    UniqueID: 7,
    MobilePhoneNumber: 8,
    CustomDate1: 9,
    CustomDate2: 10,
    CustomDate3: 11,
    CustomDate4: 12,
    CustomDate5: 13,
    CustomMoney1: 14,
    CustomMoney2: 15,
    CustomMoney3: 16,
    CustomMoney4: 17,
    CustomMoney5: 18,
    CustomText1: 19,
    CustomText2: 20,
    CustomText3: 21,
    CustomText4: 22,
    CustomText5: 23,
    CustomText6: 24,
    CustomText7: 25,
    CustomText8: 26,
    CustomText9: 27,
    CustomText10: 28,
    WorkState: 29,
    HireDate: 30,
    Department: 31,
    Division: 32,
    Location: 33,
    Region: 34,
    BusinessUnit: 35,
    PayGroup: 36,
};

export const ReportDefinitionCodes = {
    EVENT_LOG: 'event_log',
    USER_REPORT: 'user_report',
    INDIVIDUAL_REPORT: 'individual_report',
    MOST_VISITED_PAGES: 'most_visited_pages',
    MOST_CLICKED_CONTENT: 'most_clicked_content',
};

export const ReportStatusIds = {
    PENDING: 1,
    COMPLETED: 2,
    ERROR: 3,
    IN_PROGRESS: 4,
};
